<template>
    <div>
        <MobileTitleWithBack v-if="$vuetify.breakpoint.xsOnly">
            User Information
        </MobileTitleWithBack>
        <v-row
            :class="$vuetify.breakpoint.smAndUp ? 'pl-8' : ''"
        >
            <v-col
                v-if="$vuetify.breakpoint.smAndUp"
                cols="4"
            >
                <ProfileNavigation />
            </v-col>
            <v-col>
                <UserInfo />
            </v-col>
        </v-row>
    </div>
</template>
<script>
import MobileTitleWithBack from '@/components/MobileTitleWithBack';
import ProfileNavigation from '@/components/ProfileSettings/ProfileNavigation';
import UserInfo from '@/components/ProfileSettings/UserInfo';

export default {
    components: {
        MobileTitleWithBack,
        ProfileNavigation,
        UserInfo,
    },
};
</script>
